module.exports = __webpack_public_path__ + "static/img/icon_youtube.9f4e0a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channelServices/icon_youtube.png
// module id = 5rb9
// module chunks = 0